module.exports = __webpack_public_path__ + "img/vip3.aa30a5ea.png";